import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const UserIdentityRequestSchema = z.object({
    email: z.string().email(),
    link: z.string(),
    buyer: z.string(),
});

export class UserIdentityRequest extends FromSchema(UserIdentityRequestSchema) {
    email: string;
    link: string;
    buyer: string;
}
